import React from "react";
import "./Career.css";

const Career = () => {
  return (
    <div className="career_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam illo
        aliquid dignissimos fugit neque, dolor adipisci laboriosam ipsum nihil
        officia, cum, esse eligendi. Iste aspernatur neque culpa quas? Dolore,
        ipsum?
      </h1>
    </div>
  );
};

export default Career;
